import TextWithTitleBlock from './TextWithTitleBlock';

export default TextWithTitleBlock;
